import script from "./HomeBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeBanner.vue?vue&type=script&setup=true&lang=js"

import "@/features/home/styles/HomeBanner.css?vue&type=style&index=0&id=22925089&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22925089"]])

export default __exports__